import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loading from '../../Loading/LoadingView';
import AdvForm from '../../../CommonComponents/AdvForm';
import ValidationErrors from '../../ValidationErrors/ValidationErrorsContainer';
import AdvInputWrapper from '../../../CommonComponents/AdvInputWrapper';
import AdvInput, { advInputTextChanged } from '../../../CommonComponents/AdvInput';
import {
  createCustomPropType,
  isNumeric,
  isNumericFormatted,
  isUuid,
} from '../../../../js/app/react/validators';
import Footer from '../../Footer/FooterContainer';

export class DistributionAmount extends Component {
  constructor(props) {
    super(props);

    this.onDistributionAmountBlur = this.onDistributionAmountBlur.bind(this);
  }

  onDistributionAmountBlur(valueArg) {
    const { goalId, clientId, whatIfTemplate, storeData, whatIf } = this.props;

    let value = valueArg;

    if (isNumericFormatted(valueArg)) {
      if (typeof valueArg === 'string') {
        value = +valueArg.replace(/,/g, '');
      }
    } else {
      value = 0;
    }

    advInputTextChanged(
      clientId,
      storeData(goalId, whatIfTemplate.WhatIfType),
      whatIf.DistributionStrategyType === 0
        ? 'WhatIf.DistributionPercentage'
        : 'WhatIf.DistributionDollarAmount',
    )(value);
  }

  render() {
    const {
      groupTitle,
      clientId,
      title,
      whatIf,
      isLoading,
      applyWhatIf,
      fpId,
      goalId,
      whatIfTemplate,
      storeData,
    } = this.props;

    const { DistributionDollarAmount, DistributionPercentage, DistributionStrategyType } = whatIf;
    const distributionValue =
      DistributionStrategyType === 0 ? DistributionPercentage : DistributionDollarAmount;

    return (
      <div className="what-ifs-layout">
        {isLoading && <Loading />}

        <div className="what-ifs-section what-ifs-layout-header">
          <h3>What-If...</h3>
        </div>

        <div className="what-ifs-layout-content">
          <h4 className="what-if-group-title">{groupTitle}</h4>

          <AdvForm>
            <ValidationErrors clientId={clientId} />

            <ul className="what-ifs-form-fields what-ifs-box loaded">
              <li className="what-ifs-form-field">
                <h5 className="what-if-title">{title}</h5>
              </li>

              <li className="what-ifs-decumulation-distribution-amount-form-field">
                <AdvInputWrapper
                  hasCurrency={DistributionStrategyType !== 0}
                  hasPercentage={DistributionStrategyType === 0}
                  className="what-ifs-input-wrapper"
                >
                  <AdvInput
                    autoComplete="off"
                    type="text"
                    dataType={DistributionStrategyType === 0 ? 'interest' : 'money'}
                    maxLength="14"
                    onBlur={this.onDistributionAmountBlur}
                    value={distributionValue}
                    className="what-ifs-input"
                  />
                </AdvInputWrapper>

                <label
                  className="what-ifs-age-label what-ifs-checkbox"
                  htmlFor="decumulation-whatif--use-percentage"
                >
                  <input
                    type="checkbox"
                    id="decumulation-whatif--use-percentage"
                    className="what-ifs-checkbox-toggle"
                    checked={DistributionStrategyType === 0}
                    onChange={evt =>
                      advInputTextChanged(
                        clientId,
                        storeData(goalId, whatIfTemplate.WhatIfType),
                        'WhatIf.DistributionStrategyType',
                      )(evt.target.checked ? 0 : 1)
                    }
                  />
                  <i className="what-ifs-checkbox-mark" />
                  <span className="what-ifs-checkbox-label-text">Use Percentage</span>
                </label>
              </li>
            </ul>
          </AdvForm>
        </div>

        <Footer
          clientId={clientId}
          applyToPlanCallback={applyWhatIf(clientId, fpId, goalId, whatIf, whatIfTemplate)}
        />
      </div>
    );
  }
}

DistributionAmount.defaultProps = {
  title: 'Untitled What If',
  groupTitle: 'Untitled What If Group',
};

DistributionAmount.propTypes = {
  goalId: createCustomPropType(isUuid).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  title: PropTypes.string,
  groupTitle: PropTypes.string,
  whatIf: PropTypes.shape({
    DistributionDollarAmount: PropTypes.number,
    DistributionPercentage: PropTypes.number,
    DistributionStrategyType: PropTypes.oneOf([0, 1]),
  }).isRequired,
  whatIfTemplate: PropTypes.shape({
    WhatIfType: PropTypes.number,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  applyWhatIf: PropTypes.func.isRequired,
  storeData: PropTypes.func.isRequired,
};
